import { translate } from 'shared/lib/i18n.tsx';
import { defaultRemoteViewLayout } from 'shared/lib/tv-game/nativeLayout.ts';
import { getRemoteCalibStandZoneMetrics } from 'shared/lib/tv-game/remoteCalibStandZone.ts';

import { drawRemoteCalibrationStandZone } from '../infrastructure/canvas/room/calibrationShared.ts';
import { wrapCanvasText } from '../infrastructure/canvas/room/canvasHelpers.ts';

import { drawFillProgress } from './BirdFlightDisplayEngine.ts';

/**
 * Экран «встаньте в зону» для игр, где телефон калибруется сам (Sky Race, IQ): силуэт по пояс, рамка заполняется
 * по прогрессу калибровки на телефоне (0…1). Подложка на весь экран и непрозрачная: страница игры под ней не нужна.
 */
export function drawUpperBodyCalibration(ctx: CanvasRenderingContext2D, W: number, H: number, progress: number): void {
  const layout = defaultRemoteViewLayout(W, H);
  const backdrop = ctx.createLinearGradient(0, 0, 0, H);
  backdrop.addColorStop(0, '#040c26');
  backdrop.addColorStop(0.6, '#07143a');
  backdrop.addColorStop(1, '#04081c');
  ctx.fillStyle = backdrop;
  ctx.fillRect(0, 0, W, H);
  drawRemoteCalibrationStandZone(ctx, layout, 'upper');

  const {
    cx, boxX, boxY, boxW, boxH, borderW,
  } = getRemoteCalibStandZoneMetrics(layout, 'upper');
  drawFillProgress(ctx, {
    x: boxX, y: boxY, w: boxW, h: boxH, lineWidth: borderW * 1.6, progress,
  });
  const px = Math.round(Math.min(layout.gameHeight * 0.034, boxW / 14, 46));
  const padX = boxW * 0.05;
  const sw = boxW - padX * 2;
  const lineGap = px * 1.45;
  ctx.save();
  ctx.font = `600 ${px}px Arial, sans-serif`;
  const lines = wrapCanvasText(ctx, translate('calib.hint.upper_body'), sw);
  const padV = px * 0.55;
  const sy = boxY + borderW * 2.2 + Math.max(10, layout.gameHeight * 0.015);
  ctx.fillStyle = 'rgba(0,0,0,0.58)';
  ctx.beginPath();
  ctx.rect(boxX + padX, sy, sw, lines.length * lineGap + padV * 2);
  ctx.fill();
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillStyle = '#ffe566';
  lines.forEach((line, i) => ctx.fillText(line, cx, sy + padV + lineGap * (i + 0.5)));
  ctx.restore();
}
